
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 12.26 16\" id=\"download\" ><title>download</title><path class=\"cls-1\" d=\"M12.26 6.73H8.75V0H3.51v6.73H0l6.13 6.67zM0 16h12.26v-1.4H0z\" data-name=\"Layer 2\"/></symbol>";
module.exports = sprite.add(image, "download");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/download.svg
// module id = 648
// module chunks = 1474